import { render } from "./ClassRecordDetails.vue?vue&type=template&id=03fffd10"
import script from "./ClassRecordDetails.vue?vue&type=script&lang=js"
export * from "./ClassRecordDetails.vue?vue&type=script&lang=js"

import "./ClassRecordDetails.vue?vue&type=style&index=0&id=03fffd10&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__